import { render } from "./HeaderPartial.vue?vue&type=template&id=124e3c9d"
import script from "./HeaderPartial.vue?vue&type=script&lang=js"
export * from "./HeaderPartial.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__